import React from "react";

const Table = ({
  data,
  columns,
  selectedItems,
  handleSelectItem,
  handleBulkSelect,
  requestSort,
  getSortArrow,
  onRowClick,
  isLoading,
  formatters = {},
}) => {
  return (
    <table className="table">
      <thead>
        <tr>
          <th className="checkbox-column">
            <input
              type="checkbox"
              onChange={() => handleBulkSelect(data)}
              checked={selectedItems.length === data.length}
              disabled={isLoading}
            />
          </th>
          {columns.map((column) => (
            <th key={column.key} onClick={() => requestSort(column.key)}>
              {column.label} {getSortArrow(column.key)}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {isLoading ? (
          <tr>
            <td colSpan={columns.length + 1}>Loading...</td>
          </tr>
        ) : data && data.length > 0 ? (
          data.map((item) => (
            <tr
              key={item.id}
              onClick={(e) => {
                // Only call onRowClick if it's provided and the target is not an input
                if (onRowClick && e.target.tagName !== "INPUT") {
                  onRowClick(e, item);
                }
              }}
            >
              <td
                className="checkbox-column"
                onClick={(e) => e.stopPropagation()}
              >
                <input
                  type="checkbox"
                  onClick={(e) => e.stopPropagation()}
                  onChange={(e) => {
                    handleSelectItem(item);
                  }}
                  checked={selectedItems.some(
                    (selected) => selected.id === item.id
                  )}
                />
              </td>
              {columns.map((column) => (
                <td key={column.key}>
                  {formatters[column.key]
                    ? formatters[column.key](item[column.key])
                    : item[column.key]}
                </td>
              ))}
            </tr>
          ))
        ) : (
          <tr>
            <td colSpan={columns.length + 1}>
              Looks like you do not have any courses or classlists yet. Click
              the Create button to start...
            </td>
          </tr>
        )}
      </tbody>
    </table>
  );
};

export default Table;
